import React, { useState, useEffect } from "react";
import {Row, Container, Col, Form } from "react-bootstrap";
import LeftIndent from "utils/LeftIndent";



export default function Customizations(props) {

  return (
    <LeftIndent>
    <Container fluid className="">
      <Row className="">
       <Col className="p-5" style={{ backgroundColor: "#E1E1E1", paddingLeft:"23px" }}>
         <p>CUSTOMIZATIONS PAGE</p>
       </Col>
     </Row>
    </Container>
    </LeftIndent>
  );
}

